(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('rmsActivityMainInputPanel', rmsActivityMainInputPanelComponent);

    function rmsActivityMainInputPanelComponent() {
        return {
            restrict: 'E',
            scope: {
                options: '=',
            },
            templateUrl: function(elem, attrs) {
                if (attrs.template) {
                    return 'common/app/components/activities/activity-input-panel/' + attrs.template;
                }
                return 'common/app/components/activities/activity-input-panel/activity-main-input-panel';
            },
            controller: rmsActivityMainInputPanelComponentCtrl,
            controllerAs: 'vm',
            bindToController: true,
        };
    }

    function rmsActivityMainInputPanelComponentCtrl(ActivitiesService, $timeout, lodash, ActivityInputService, GenericModel, $scope) {
        var vm = this;

        this.$onInit = function() {
            vm.currentData = {};

            init();

            vm.add = add;
            vm.discard = discard;
            vm.selectType = selectType;
        }

        function init() {
            vm.selectedActivityType = vm.options.activityTypes[0];
            vm.currentData = ActivityInputService.initInputOptions(
                vm.currentData,
                vm.selectedActivityType,
                vm.options.inputOptions,
                lodash.get(vm.options, 'attachmentOptions', {})
            );

            if (lodash.has(vm.options, 'selection')) {
                vm.currentData.selection = vm.options.selection;
            }

            vm.defaultModel = lodash.get(vm.options, 'defaultModel', {});
        }

        function add() {
            $timeout(function() {
                vm.submitting = true;
                var promise = ActivitiesService.save(vm.getModel(), vm.selectedActivityType, vm.options.inputOptions);
                promise.$promise.then(function(res) {

                    if (lodash.has(vm.options, 'events.add_success')) {
                        $scope.$emit(vm.options.events.add_success, res);
                    }
                    vm.inputValidationErrorMessage = '';
                    vm.submitting = false;
                    vm.discard();
                    ActivitiesService.refreshActivities();
                }, function(err) {
                    switch (err.status) {
                        case 422:
                            vm.inputValidationErrorMessage = lodash.flatMap(err.data.rules).join(', ');
                            break;
                    }
                    // mem.inputValidationError = err.data;
                    console.warn(err); // eslint-disable-line no-console
                    vm.submitting = false;
                });
            });
        }

        function selectType(type) {
            vm.selectedActivityType = type;
            vm.currentData = ActivityInputService.initInputOptions(vm.currentData, vm.selectedActivityType, vm.options.inputOptions);
        }

        function discard() {
            vm.reset();
            vm.inputValidationErrorMessage = '';

            if (lodash.has(vm, 'onDiscard')) {
                vm.onDiscard();
            }
        }
    }
})();